import { render, staticRenderFns } from "./PillsDuplicates.vue?vue&type=template&id=14ca4a2e&scoped=true&"
import script from "./PillsDuplicates.vue?vue&type=script&lang=js&"
export * from "./PillsDuplicates.vue?vue&type=script&lang=js&"
import style0 from "./PillsDuplicates.vue?vue&type=style&index=0&id=14ca4a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca4a2e",
  null
  
)

export default component.exports